export default {
  title: 'Bliv en del af {{name}}!',
  default_program_name: 'Belønningsklub',
  savings_highlight: {
    title: 'Bliv belønnet. Hver ordre, hver gang.',
    subtitle: 'Tilmeld dig på få sekunder, og begynd at optjene point.',
  },
  how_it_works: {
    label: 'Sådan fungerer det',
    step_1: {
      title: 'Tilmeld dig på 30 sek.',
      desc: 'Kun dit telefonnummer',
    },
    step_2: {
      title: 'Bestil og optjen',
      desc: '{{percentage}}% tilbage på hver ordre',
    },
    step_3: {
      title: 'Indløs og spar',
      desc: 'Op til {{amount}} i rabat pr. ordre',
    },
  },
  profile: {
    verified_title: 'Telefon bekræftet!',
    verified_subtitle: 'Udfyld din profil for at begynde at optjene.',
  },
  form: {
    phone_number: {
      label: 'Telefonnummer',
      description: 'Vi sender en bekræftelseskode for at sikre, at det er dig.',
      placeholder: 'Telefonnummer',
    },
    birthday: {
      label: 'Fødselsdag – dag og måned er nok til at få en gave 🥳',
      placeholder: 'Fødselsdag (valgfrit)',
      parts: {
        month: 'Måned',
        day: 'Dag',
      },
    },
  },
  terms:
    'Ved at tilmelde dig accepterer du vores <TermsLink>vilkår og betingelser</TermsLink> og samtykker til vores <PrivacyPolicyLink>privatlivspolitik</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Fortsæt',
    verify: 'Bekræft',
    complete: 'Fuldfør tilmelding',
  },
  toasts: {
    login_success: 'Du er nu logget ind',
    invalid_code: 'Ugyldig kode. Prøv igen.',
    failed_to_update_profile: 'Profilen kunne ikke opdateres. Prøv igen.',
  },
};
